import styled from 'styled-components'
import { breakpoints } from '../assets/styles/mediaBreakpoints'
import { PillButton } from '../components/common/stand_alone/pillButton'

const QuizPage = () => {
  return (
    <QuizSection>
      <QuizContentContainer>
        <QuizLogo src="/images/quiz/logo_dark_green.png" />
        <QuizTitleContainer>
          <QuizTitle>Discover your SDG Superhero</QuizTitle>
          <p>
            Take the &apos;SDG Quest&apos; and discover your unique Sustainable
            Development Goal! Find the global mission that aligns with your
            values and join a community of changemakers. Start now and make an
            impact
          </p>
        </QuizTitleContainer>
        <QuizDurationContainer>
          <img src="/icons/clock.svg" />
          <h6>Duration 10 mins</h6>
        </QuizDurationContainer>
        <PillButton title="Take the quiz" link="/quiz-p" />
      </QuizContentContainer>
    </QuizSection>
  )
}

const QuizSection = styled.div`
  width: 100%;
  background-image: url('/images/quiz/bg_first_quiz.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 120px;
  padding-bottom: 120px;
  @media (max-width: ${breakpoints.mobile}px) {
    padding: 64px 24px;
  }
`
const QuizContentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 640px;
  gap: 32px;
  text-align: center;
  @media (max-width: ${breakpoints.mobile}px) {
    max-width: 100%;
  }
`
const QuizTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  width: 100%;
`
const QuizTitle = styled.h1`
  @media (max-width: ${breakpoints.mobile}px) {
    font-size: 40px;
  }
`
const QuizLogo = styled.img`
  width: 72px;
`
const QuizDurationContainer = styled.div`
  display: flex;
  gap: 8px;
`

export default QuizPage
